import { render, staticRenderFns } from "./LeaveBreakdownDeductionInfo.vue?vue&type=template&id=68bd5f74"
import script from "./LeaveBreakdownDeductionInfo.vue?vue&type=script&lang=js"
export * from "./LeaveBreakdownDeductionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports